import UpgradePlanModal from "@/components/global/modals/upgrade_plan_modal.vue";

export default {
  methods: {
    trackAndRedirectToUpgrade(reason, params = {}) {
      this.$trackEvent(`upgrade_clicked_${reason}`, {
        reason,
        ...params,
      });

      this.$egModal.show("upgrade-plan-modal", {
        component: UpgradePlanModal,
        props: {
          currentPlan: this.accountProvider?.subscription?.plan,
        },
      });
    },
  },
};
